import CostCenterForm from '@/view/forms/cost-center-form'
import { List, PlusCircle } from 'lucide-react'
import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { DisplayCostCenter } from './panels/display-cost-center'

interface ICostCenterPage {}

export default function CostCenterPage(props: ICostCenterPage) {
  console.log(props)

  const [tab, setTab] = useState('cost-center')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between">
          <Tabs defaultValue="cost-center" className="w-[320px]" onValueChange={setTab}>
            <TabsList>
              <TabsTrigger value="cost-center" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <List className="text-sm" />
                Centros de custo
              </TabsTrigger>
              <TabsTrigger value="register-cost-center" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Cadastrar Centro de Custo
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <div className="flex gap-2">
            {/* <Button className="text-acelerait-black flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button> */}
          </div>
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab == 'cost-center' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Centros de custo</h3>
                <p className="text-sm text-acelerafit-gray-dark">Gerencie e acompanhe o cadastro, status e informações dos Centros de custo.</p>
              </header>
              <div className="h-container-members overflow-hidden">
                <DisplayCostCenter />
              </div>
            </>
          )}

          {tab == 'register-cost-center' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar Centro de Custo</h3>
                <p className="text-sm text-acelerafit-gray-dark">Preencha as informações abaixo para registrar um novo Centro de Custo.</p>
              </header>
              <CostCenterForm />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
